import React from 'react';
import Axios from 'axios';
import AutoSuggestPlayer from '../../shared/AutoSuggest/AutoSuggestPlayer';

const autoSuggTheme = {
	container: 'react-autosuggest-std__container',
	input: 'react-autosuggest-std__input',
	inputOpen: 'react-autosuggest-std__input--open',
	inputFocused: 'react-autosuggest-std__input--focused',
	suggestionsContainer: 'react-autosuggest-std__suggestions-container',
	suggestionsContainerOpen: 'react-autosuggest-std__suggestions-container--open',
	suggestionsList: 'react-autosuggest-std__suggestions-list',
	suggestion: 'react-autosuggest-std__suggestion',
	suggestionHighlighted: 'react-autosuggest-std__suggestion--highlighted',
	//suggestionFirst: 'react-autosuggest__suggestion--first',
	//sectionContainer: 'react-autosuggest__section-container',
	//sectionContainerFirst: 'react-autosuggest__section-container--first',
	//sectionTitle: 'react-autosuggest__section-title'
};

class PlayerMerging extends React.Component {

  constructor(props) {
		super(props);
		this.state = {
			loading: false,
			playerId1: '',
			playerId2: '',
			playerFullname1: '',
			playerFullname2: ''
		};
	
		this.handleClickMerge = this.handleClickMerge.bind(this);
		this.handleChangeP1 = this.handleChangeP1.bind(this);
		this.handleChangeP2 = this.handleChangeP2.bind(this);
	}

  render() {
    // console.log('PlayerMerging: RENDER');
    // console.log(this.state);
    return (
      <div>
      <div className="row">
      <div className="col-md-12">
        <h5>Fusion de joueurs</h5>
        <p>{(this.state.loading === true) ? <span>Fusion en cours</span> : <span>&nbsp;</span>}</p>
      </div>
      </div>

      <div className="row">
      <div className="col-md-4">
      	Joueur 1: recevra les statistiques
				<AutoSuggestPlayer id='playerId1' theme={autoSuggTheme} playerId={this.state.playerId1} 
					dataChange={this.handleChangeP1} />
				ID: {this.state.playerId1}
      </div>
      <div className="col-md-4">
      	Joueur 2: à fusionner dans Joueur 1
				<AutoSuggestPlayer id='playerId2' theme={autoSuggTheme} playerId={this.state.playerId2} 
					dataChange={this.handleChangeP2} />
				ID: {this.state.playerId2}
      </div>
      <div className="col-md-4">
      	<br/>
				<input type="button" className="btn btn-primary" value="Fusionner" onClick={this.handleClickMerge} />
      </div>
     	</div>
   		</div>
	  );
  }

	handleClickMerge() {
		var playerId1 = this.state.playerId1;
		var playerId2 = this.state.playerId2;

		if ((playerId1 === '') || (playerId1 === '0') || 
			(playerId2 === '') || (playerId2 === '0')) {

			alert('Sélectionner des joueurs à fusionner adéquatement');

		} else {
			this.setState({loading: true});

			Axios.post('/api/players/mergePlayers',
			{
				playerId1: playerId1,
				playerId2: playerId2
			})
			.then(response => {
				this.setState({
					loading: false,
					playerId1: '',
					playerId2: ''
				});
	
				alert('Joueurs fusionnés.  Le joueur ' + this.state.playerFullname2 + ' a été supprimé.');
				console.log(response);
			});
		}
	}

	handleChangeP1(playerId, playerFullname) {
    this.setState({
    	playerId1: playerId,
    	playerFullname1: playerFullname
    });
	}

	handleChangeP2(playerId, playerFullname) {
    this.setState({
    	playerId2: playerId,
    	playerFullname2: playerFullname
    });
	}

}

export default PlayerMerging;